import { createEpicFromAsyncAction, createEpicFromAsyncActionEmptyRequest } from '../../../utils';
import { getAgreementTags } from '../../agreement/redux/agreementSlices';
import { enqueueSnackbar } from '../../ui/redux/uiSlices';
import { createTag, deleteTag, getAllTags, updateTag } from './tagSlices';

const tags$ = createEpicFromAsyncActionEmptyRequest(getAllTags, ({ tagClient }) => {
    return tagClient.getAll();
});

const agreementTags$ = createEpicFromAsyncAction(getAgreementTags, (req, { tagClient }) => {
    return tagClient.getForAgreement(req);
});

const createTag$ = createEpicFromAsyncAction(
    createTag,
    (req, { tagClient }) => {
        return tagClient.createTag(req);
    },
    req =>
        enqueueSnackbar({ message: `Tag '${req.name}' created`, severity: 'success', autoHideDuration: 3000 })
);

const updateTag$ = createEpicFromAsyncAction(
    updateTag,
    (req, { tagClient }) => tagClient.updateTag(req).then(() => req),
    () =>
        enqueueSnackbar({
            message: `Tag updated`,
            severity: 'success',
            autoHideDuration: 3000
        })
);

const deleteTag$ = createEpicFromAsyncAction(
    deleteTag,
    (req, { tagClient }) => tagClient.deleteTag(req).then(() => req),
    () =>
        enqueueSnackbar({
            message: `Tag deleted`,
            severity: 'success',
            autoHideDuration: 3000
        })
);

export default [tags$, agreementTags$, createTag$, updateTag$, deleteTag$];
